import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Breakpoint, Columns, MobileBreakpoint, TabletBreakpoint } from '../../styles/functions';
import SidebarRender from './SidebarRender'

interface P {
  children?: ReactNode
  isSticky: boolean
}

const SidebarContainer: React.FC<P> = ({ 
  isSticky, 
  children, 
}: P) => {
  return (
    <Container $isSticky={isSticky}>
      {children || <SidebarRender />}
    </Container>
  );
}

const Container = styled.div<{$isSticky: boolean}>`
  top: var(--spacing-page-top);
  margin-bottom: auto;
  

  ${MobileBreakpoint} {
    margin-bottom: 32px;
  }

  ${Breakpoint('tablet', 'min')} {
    width: ${Columns(5)};
  }

  ${TabletBreakpoint(`
    width: ${Columns(6)};
  `)}
  
  ${Breakpoint('mobile', 'min')} {
  ${(props) => props.$isSticky 
    ? css`
      position: sticky;
      float: left;
      ` 
      : css`
      position: absolute;
      `
    }
  }

`


export default SidebarContainer